export default __webpack_public_path__ + "static/media/3in1.0cc4e8ba.gif";